import { CaretRightOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

import { RFIQuestionType, RFITicket } from './types';

const AdditionalQuestionAnswers = (props: {
  items: RFITicket['qna_items'];
}) => {
  return (
    <Wrapper
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
    >
      <Collapse.Panel
        key="answers"
        header={<i>Additional Questions Answer's</i>}
      >
        <ul>
          {props.items.map(item => {
            const ender =
              item.question.endsWith('?') || item.question.endsWith(':')
                ? ''
                : ':';
            let answer = item.answer || '-';

            // format date answers
            const [dateType, isoStr] = answer.split('|');
            let isValidDate = moment(answer).isValid();
            if (answer.includes('|')) {
              if (isoStr) {
                isValidDate = moment(isoStr).isValid();
              }
            }
            if (isValidDate) {
              if (dateType === RFIQuestionType.DATE) {
                answer = moment(isoStr).format('DD MMM YYYY');
              } else if (dateType === RFIQuestionType.TIME) {
                answer = moment(isoStr).format('HH:mm');
              } else {
                answer = moment(isoStr).format('DD MMM YYYY, HH:mm');
              }
            }

            return (
              <li key={item.id} className="answer">
                <p className="qns">
                  <b>
                    {item.question}
                    {ender}
                  </b>
                </p>
                <p className="ans">{answer}</p>
              </li>
            );
          })}
        </ul>
      </Collapse.Panel>
    </Wrapper>
  );
};

const Wrapper = styled(Collapse)`
  &.ant-collapse {
    border: none;
    background: none;
    margin-top: 10px;

    > .ant-collapse-item {
      border: none;

      .ant-collapse-header {
        padding: 0;
        font-size: 12px;

        &:hover {
          text-decoration: underline;
        }

        > div span.anticon {
          margin-right: 0;
          font-size: 10px;
        }
      }

      .ant-collapse-content,
      .ant-collapse-content-active {
        border: none;
        background: none;

        .ant-collapse-content-box {
          padding: 0;

          ul {
            padding: 0 0 0 10px;
            margin: 5px 0 0 0;
            font-size: 12px;
            list-style: none;

            li.answer {
              margin-bottom: 5px;

              p {
                margin: 0;

                &.qns b {
                  font-weight: 600;
                }
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
`;

export default AdditionalQuestionAnswers;
